import forEach from '../../../../javascripts/dom/forEach';

const numbers = document.querySelectorAll('[data-js-module="o-numbers"]');

const init = async () => {
  const { default: Numbers } = await import(/* webpackChunkName: "o-numbers" */ './numbers');
  forEach(numbers, (index, element) => new Numbers(element));
};

if (numbers.length) init();
